import React, { useEffect, useState } from "react";
import styles from "./CP_input.module.css";
import axios from "axios";

const CPinput = ({
  setLoading,
  geneSetType,
  PPType,
  CGdbType,
  setGeneSetType,
  geneSet,
  setGeneSet,
  setResultData,
  exampleGeneset
}) => {
  const handleGeneSetType = (type) => {
    setGeneSetType(type);
  };

  const handleSetGenes = (e) => {
    let text = e.target.value;
    text = text.replaceAll(" ", "");
    if (text.includes(";")) {
      text = text.replaceAll(";", "\n");
    }
    if (text.includes(",")) {
      text = text.replaceAll(",", "\n");
    }
    setGeneSet(text);
  };

  const handleSubmit = () => {
    setLoading(true);
    const headers = {
      accept: "*/*",
    };

    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/cp`,
      headers,
      data: {
        geneSetType,
        geneSet: geneSet.replaceAll("\n", ",").trim(),
        CGdbType,
      },
    })
      .then((res) => {
        const resultData = JSON.parse(res.data.data);
        setResultData(resultData);

        localStorage.setItem("intersec_CP", res.data.matchInfo.intersec);
        localStorage.setItem("total_CP", res.data.matchInfo.total);
        localStorage.setItem("percent_CP", res.data.matchInfo.percent);
        localStorage.setItem("cp", res.data.data);
      })
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const generateTestValues = () => {
    setGeneSetType("str");
    setGeneSet(exampleGeneset);
  };

  useEffect(() => {}, [geneSetType]);

  return (
    <div className={styles.section}>
      <h1 className={styles.mainTitle}>◼️ Pathway Prioritization ({PPType})</h1>
      <div className={styles.container}>
        <div className={styles.inputCnts} style={{marginRight :'80px', border : '2px solid lightgrey', padding :'15px 50px 30px 30px', borderRadius :'10px'}}>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>1</span>Select gene identifier
              type{" "}
            </h4>
            <div className={styles.btnCnt}>
              <button
                className={`${styles.button} ${
                  geneSetType === "str" ? styles.selected : ""
                }`}
                onClick={() => handleGeneSetType("str")}
              >
                HGNC symbol
              </button>
              <button
                className={`${styles.button} ${
                  geneSetType === "int" ? styles.selected : ""
                }`}
                onClick={() => handleGeneSetType("int")}
              >
                Entrez ID
              </button>
            </div>
          </div>
          <div className={styles.inputCnt}>
            <h4 className={styles.subTitle}>
              <span className={styles.stepNum}>2</span>Input user defined gene
              set{" "}
              <span
                style={{
                  color: "blue",
                  fontWeight: "400",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={generateTestValues}
              >
                {" "}
                (example)
              </span>
            </h4>
            <textarea
              placeholder={
                geneSetType === "int"
                  ? "ex.1,2,3,4,..."
                  : "ex.RSPO3, KRAS, BRCA1, ZZZ3..."
              }
              className={styles.input}
              onChange={(e) => handleSetGenes(e)}
              value={geneSet === exampleGeneset ? exampleGeneset : geneSet}
            />
          </div>
          <button className={styles.submitBtn} onClick={handleSubmit}>
            Submit
          </button>
        </div>

        <div className={styles.desCnt}>
          <p className={styles.desc}>
          Assigns the user-specified pathway (gene set) to one of {" "}
            <span style={{ fontWeight: "bold" }}>
              four levels of {PPType} pathway likelihood
            </span>
            by assessing the enrichment of two or more consensus {PPType} genes in a given pathway. 
            Cutoff p-values for each level are dynamically set based on gene set size using 
            the results of our extensive permutation test.
          </p>
          <p className={styles.details}>Details</p>
        </div>
      </div>
    </div>
  );
};

export default CPinput;
